var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"artwork by Gee Lee","src":require("./assets/bella-art.jpg"),"width":"300px"}}),_c('Home')],1)}
var staticRenderFns = []

export { render, staticRenderFns }